<template>
    <div>
        <h3 class="mb-3 mt-2">Cause DropDown</h3>
        <vx-card noShadow noRound>
            <vs-row>
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3">
                    <vs-input
                        v-model="cause.name"
                        label="Name"
                        class="w-full"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.name">
                        {{ api_errors.name.join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3">
                    <InputSelect
                        :model.sync="cause.cause_type"
                        label="Cause Type"
                        placeholder="Choose ..."
                        container_class="w-auto input-custom-dropdown"
                        :options="cause_type_options"
                        :multiple="false"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.cause_type">
                        {{ api_errors.cause_type.join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3">
                    <InputSelect
                        :model.sync="cause.issue_type_category"
                        label="Issue Type Category"
                        placeholder="Choose ..."
                        container_class="w-auto input-custom-dropdown"
                        :options="issue_type_category_options"
                        :multiple="false"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.issue_type_category">
                        {{ api_errors.issue_type_category.join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3">
                    <label class="vs-input--label block">Is Active</label>
                    <div class="flex mt-3 align-center">
                        <vs-radio v-model="cause.active" vs-name="active" :vs-value="true">Yes</vs-radio>
                        <vs-radio v-model="cause.active" vs-name="active" :vs-value="false" class="mx-3">No</vs-radio>
                    </div>
                    <small class="block text-danger mt-1" v-if="api_errors.active">
                        {{ api_errors.active.join(', ') }}
                    </small>
                </vs-col>
            </vs-row>
            <vs-row class="mt-base">
                <vs-col class="text-center">
                    <vs-button @click="save" :disabled="submit_disabled">
                        Save
                    </vs-button>
                </vs-col>
            </vs-row>
        </vx-card>
    </div>
</template>

<script>
import { Request } from '../../../utils/requests'

export default {
    data() {
        return {
            cause_id: this.$route.params.cause_id,

            cause: {
                name: null,
                active: true,
                cause_type: 'p',
                issue_type_category: null
            },

            cause_type_options: [
                {value: 'p', label: "Primary"},
                {value: 's', label: "Secondary"},
            ],

            issue_type_category_options: [
                {value: 'incident', label: "Incident"},
                {value: 'road_user_accident', label: "Road User Accident"},
            ],

            submit_disabled: false,
            api_errors: {}
        }
    },
    watch: {
        "$route.params.cause_id"(newV, oldV) {
            if (newV == oldV) return;
            this.init();
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.cause_id = this.$route.params.cause_id

            if (this.cause_id) this.load_data()
            else this.cause = {
                name: null,
                active: true,
                cause_type: 'p',
                issue_type_category: null
            }
        },
        load_data() {
            let request_method = 'GET', url = this.$store.state.apiendpoints.cause_get + this.cause_id + "/"
            
            this.$vs.loading()
            
            Request(this, request_method, url).then(
                res => {
                    this.$vs.loading.close()
                    this.cause = res
                },
                err => {
                    this.$vs.loading.close()
                    
                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "An unknown error occurred! Please try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        save() {
            let request_method = 'POST', url = this.$store.state.apiendpoints.cause_get
            if (this.cause_id) {
                request_method = 'PUT'
                url += this.cause_id + '/'
            }

            let payload = this.cause

            this.submit_disabled = true

            Request(this, request_method, url, null, payload).then(
                res => {
                    this.submit_disabled = false
                    this.cause = res
                    
                    this.$vs.notify({
                        time: 3000,
                        title: 'Saved',
                        text: "Saved Successfully!",
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                    this.$router.push({name: 'cause-list'})
                },
                err => {
                    this.submit_disabled = false
                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 3000,
                            title: 'Error',
                            text: "Please fix the errors and try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 3000,
                            title: 'Error',
                            text: "An unknown error occurred! Please try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        }
    }
}
</script>